import { render, staticRenderFns } from "./TournamentStandingsGame.vue?vue&type=template&id=2d7ad9ba&"
import script from "./TournamentStandingsGame.vue?vue&type=script&lang=js&"
export * from "./TournamentStandingsGame.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStandingsGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7ad9ba')) {
      api.createRecord('2d7ad9ba', component.options)
    } else {
      api.reload('2d7ad9ba', component.options)
    }
    module.hot.accept("./TournamentStandingsGame.vue?vue&type=template&id=2d7ad9ba&", function () {
      api.rerender('2d7ad9ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentStandingsGame.vue"
export default component.exports